// extracted by mini-css-extract-plugin
export default {"coupon-template-desc-wrapper":"coupon-template-desc-wrapper_Sy849","button-group":"button-group_CVZCs","user-ids-box":"user-ids-box_Zf8WI"};